export default "__VITE_ASSET__31012c15__"